const BaseComponent = require('base/base-component');
const Service = require('helper/server');

class investmentDetailPage extends BaseComponent {
  constructor () {
    super({
      events: {
        'click .js-print': 'printArticle'
      }
    });
  }

  init () {
    this.$iframe = this.$el.find('#article-content');
    this.articleId = this.$el.find('[name=articleId]').val();
    this.printed = false;

    // 后台预览时禁用点击
    if ((location.hostname.indexOf('zxtmp') >= 0 || location.hostname.indexOf('cms') >= 0) && navigator.userAgent.indexOf('MSIE 8.0') == -1) {
      document.body.addEventListener('click', (e) => {
        e.preventDefault();
        return false;
      }, true);
    }
    // 二维码
    const type = (document.createElement('canvas').getContext) ? 'canvas' : 'table';
    const appUrl = window.location.origin+"/app/detail/index.html?id="+this.articleId;
    console.log('appUrl', appUrl);
    this.$el.find('.qr-show .qr-code').qrcode({
      render: `${type}`,
      width: 100,
      height: 100,
      text: appUrl,
    });
    // 上报访问量
    Service.visitCount({ articleId: this.articleId })
      .done(({ article, total }) => {
        $('.investment-comp-header .counting .primary').text(total);
        if (article) {
          $('[name="visitsCount"]').val(article);
        }
      }).always(() => {
        this.initializeIframe(); // 初始化文章详情
      });
  }

  buildTemplate () {
    const content = this.$el.find('[name="article-detail"]').val().replace(/contenteditable="true"/g, '')
      .replace(/<section/g, '<div')
      .replace(/<\/section>/g, '</div>');
    const author = this.$el.find('[name=author]').val();
    const documentNo = this.$el.find('[name=documentNo]').val();
    const publishDate = this.$el.find('[name=publishDate]').val();
    const visitsCount = this.$el.find('[name=visitsCount]').val();
    const title = this.$el.find('[name=title]').val();
    document.title=title;
    return `
      <!DOCTYPE html>
      <html xmlns='http://www.w3.org/1999/xhtml' class='view'>
      <head>
        <style type='text/css'>.view{padding:0;word-wrap:break-word;cursor:text;height:90%;}body{margin:8px;font-family:sans-serif;font-size:16px;}p{margin:5px 0;}
        </style>
        <style id="table">.selectTdClass{background-color:#edf5fa !important}table.noBorderTable td,table.noBorderTable th,table.noBorderTable caption{border:1px dashed #ddd !important}table{margin-bottom:10px;border-collapse:collapse;display:table;page-break-inside:auto;}tr{page-break-inside:avoid;page-break-after:auto;}thead{ display:table-header-group;}tfoot{display:table-footer-group;}td,th{padding: 5px 10px;border: 1px solid #DDD;}caption{border:1px dashed #DDD;border-bottom:0;padding:3px;text-align:center;}th{border-top:1px solid #BBB;background-color:#F7F7F7;}table tr.firstRow th{border-top-width:2px;}.ue-table-interlace-color-single{ background-color: #fcfcfc; } .ue-table-interlace-color-double{ background-color: #f7faff; }td p{margin:0;padding:0;}</style>
        <style id="list">ol,ul{margin:0;pading:0;width:95%}li{clear:both;}.list-paddingleft-1{padding-left:0}.list-paddingleft-2{padding-left:30px}.list-paddingleft-3{padding-left:60px}</style>
        <style id="pre">pre{margin:.5em 0;padding:.4em .6em;border-radius:8px;background:#f8f8f8;}</style>
        <style>.detail-info{font-size: 14px;color: #666;padding: 10px 0;margin-bottom: 20px;border-bottom: 1px dotted #999;}.detail-info span{margin-right: 20px;}</style>
        <style>.fjxx{box-sizing:border-box;}</style>
        <style>.template-law{font-size:14px;}.law-info{width:100%;background:#f9f9f9;border:1px solid #eee;text-align:left;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.law-info > tbody > tr > td{padding:5px 0;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;max-width:100px;}.law-info > tbody > tr > td p{max-width:190px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;}.law-info .text-right{text-align:right;}.law-info .info_title{height:32px;font-size:16px;color:#f00;font-weight:bold;text-align:center;}.law-info td,th{border:0;}.law-title{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}.law-title h1{width:100%;text-align:center;font-size:40px;color:#f00;text-decoration:none;font-weight:bold;margin-bottom:60px;margin:0;padding:120px 0 60px 0;}.law-title h2{border-bottom:#f00 solid 3px;line-height:50px;font-size:17px;color:#000;text-decoration:none;font-weight:normal;height:50px;width:100%;text-align:center;padding:0;margin:0 0 40px 0;}.law-title p{font-size: 20px;padding-bottom:15px;}</style>
      </head>
      <body class='view' style="overflow-y:hidden;">
      <header>
        <h1 style="text-align:center;line-height: 30px;font-size: 24px;font-weight: 500;">${this.htmlEncodeByRegExp(title)}</h1>
        <p class="detail-info" style="text-align:center;">
          <span>来源：${this.htmlEncodeByRegExp(author)}</span>
          ` + (documentNo ? `<span>文号：${this.htmlEncodeByRegExp(documentNo)}</span>` : '') +
          `<span>发布时间：${publishDate}</span>
          <span>浏览次数：</span>
          <span class="visitsCount">${visitsCount}</span>
        </p>
      </header>
      ${content}
      </body>
    </html>`;
  }

  initializeIframe () {
    this.$iframe.on('load', () => this.resizeIframe());
    const doc = this.$iframe[0].contentDocument;
    doc.open();
    doc.write(this.buildTemplate());
    doc.close();
  }

  resizeIframe () {
    const $iframe = $('#article-content');
    const iframeBodyHeight = $iframe[0].contentDocument.body.scrollHeight;
    $iframe.height((iframeBodyHeight + 40) + 'px');
  }

  printArticle () {
    const frameWindow = this.$iframe.get(0).contentWindow;

    let callPrint = function () {
      if (this.printed) {
        return;
      }
      // Fix for IE : Allow it to render the iframe
      frameWindow.focus();

      try {
        // Fix for IE11 - printng the whole page instead of the iframe content
        if (!frameWindow.document.execCommand('print', false, null)) {
          // document.execCommand returns false if it failed -http://stackoverflow.com/a/21336448/937891
          frameWindow.print();
        }
        // focus body as it is losing focus in iPad and content not getting printed
        $('body').focus();
      } catch (e) {
        frameWindow.print();
      }
    };
    setTimeout(callPrint, 50);
  }

  htmlEncodeByRegExp (str) {
    let s = '';
    if (str.length == 0) { return ''; }
    s = str.replace(/</g, '&lt;');
    s = s.replace(/>/g, '&gt;');
    return s;
  }
}
module.exports = investmentDetailPage;
